import type { LayoutPreset } from '@/visualization/services/viewport-layout-service';
import { ViewportType } from '@/visualization/viewports/types';

/**
 * Single viewport layout (1x1).
 */
export const LAYOUT_SINGLE: LayoutPreset = {
    name: 'single',
    label: 'Single View',
    rows: 1,
    cols: 1,
    viewports: [
        {
            slotKind: 'viewport',
            id: 'main',
            label: 'Main',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 1,
            options: {
                showOrientationWidget: true,
            },
        },
    ],
};

/**
 * Side by side layout (1x2).
 */
export const LAYOUT_SIDE_BY_SIDE: LayoutPreset = {
    name: 'side-by-side',
    label: 'Side by Side',
    rows: 1,
    cols: 2,
    viewports: [
        {
            slotKind: 'viewport',
            id: 'left',
            label: 'centerline',
            type: ViewportType.SLICE_OBLIQUE,
            row: 1,
            col: 1,
            options: {
                showOrientationWidget: true,
            },
        },
        {
            slotKind: 'viewport',
            id: 'right',
            label: '3D',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 2,
            options: {
                showOrientationWidget: true,
            },
        },
    ],
};

/**
 * Quad layout (2x2).
 */
export const LAYOUT_QUAD: LayoutPreset = {
    name: 'quad',
    label: 'Quad View',
    rows: 2,
    cols: 2,
    viewports: [
        {
            slotKind: 'viewport',
            id: 'top-left',
            label: 'Axial',
            type: ViewportType.SLICE_AXIAL,
            row: 1,
            col: 1,
            options: { showOrientationWidget: true },
        },
        {
            slotKind: 'viewport',
            id: 'top-right',
            label: '3D Volume',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 2,
            options: { showOrientationWidget: true },
        },
        {
            slotKind: 'viewport',
            id: 'bottom-left',
            label: 'Coronal',
            type: ViewportType.SLICE_CORONAL,
            row: 2,
            col: 1,
            options: { showOrientationWidget: true },
        },
        {
            slotKind: 'viewport',
            id: 'bottom-right',
            label: 'Sagittal',
            type: ViewportType.SLICE_SAGITTAL,
            row: 2,
            col: 2,
            options: { showOrientationWidget: true },
        },
    ],
};

/** All common layout presets. */
export const COMMON_LAYOUTS: LayoutPreset[] = [LAYOUT_SINGLE, LAYOUT_SIDE_BY_SIDE, LAYOUT_QUAD];
